var LoginService = (function () {
    function LoginService($localStorage, env, jwtHelper, DTS, socket) {
        this.$localStorage = $localStorage;
        this.env = env;
        this.jwtHelper = jwtHelper;
        this.DTS = DTS;
        this.socket = socket;
    }
    LoginService.prototype.setUser = function (cd) {
        var _this = this;
        var valid = false;
        var cookie = this.getCookie('io-user');
        if (cookie === null || undefined) {
            console.log('$login => no cookie found...collecting from local storage');
            if (this.$localStorage.user !== undefined) {
                valid = true;
                cookie = this.$localStorage.user;
            }
        }
        else {
            console.log('$login => cookie found');
            valid = true;
            this.$localStorage.user = cookie;
        }
        if (valid) {
            if (this.jwtHelper.isTokenExpired(cookie)) {
                return this.env.revokeUser();
            }
            console.info('$login => we have a token');
            // console.log('$token expires => ' + this.jwtHelper.getTokenExpirationDate(cookie));
            var tokendec_1 = this.jwtHelper.decodeToken(cookie);
            // console.info(`$login.ts => user roles : ` + roles);
            var hasProfile = tokendec_1.hasProfile;
            var access = tokendec_1.access;
            var allowed = false;
            var approver = false;
            var termsOk = tokendec_1.termsOk;
            if (tokendec_1.allowed = 'Y' && tokendec_1.programs.includes('SVI')) {
                allowed = true;
            }
            ;
            if (allowed) {
                //An approver can be defined as anyone in the following groups:
                // BPSO Approver, Non-BPSO Approver (managers and team leads), BPSO Admin, Non-BPSO Admin ('peers')
                if (access.bpsoApprover || access.nonBpsoApprover || access.bpsoAdmin || access.nonBpsoAdmin) {
                    approver = true;
                }
            }
            //allowed = false; //to test no Blue Group access
            if (this.$localStorage.bpuser === undefined || this.$localStorage.bpuser === {}) {
                // Ivan - Get name & uid from faces if the localStorge is undefined
                this.$localStorage.bpuser = {};
                this.DTS.getUser(tokendec_1.email)
                    .then(function (response) {
                    // console.log('response', response.data);
                    angular.forEach(response.data, function (item) {
                        // console.log('item', item);
                        // console.log('email item : ' + item.email + ' tokenemail ' + tokendec.email);
                        if (!angular.isUndefined(item.email) && !angular.isUndefined(tokendec_1.email) &&
                            (item.email.toLowerCase() == tokendec_1.email.toLowerCase())) {
                            _this.$localStorage.bpuser.name = item.name;
                            _this.$localStorage.bpuser.uid = item.uid;
                            console.log('user is : ' + _this.$localStorage.bpuser.name + ' - ' + _this.$localStorage.bpuser.uid);
                            _this.env.setUser({
                                name: _this.$localStorage.bpuser.name,
                                uid: _this.$localStorage.bpuser.uid
                            });
                        }
                        ;
                    });
                });
            }
            this.env.setUser({
                email: tokendec_1.email,
                hasProfile: hasProfile,
                token: cookie,
                loggedIn: true,
                access: access,
                allowed: allowed,
                approver: approver,
                termsOk: termsOk
            });
            this.socket.emit('module', {
                module: {
                    application: 'dmt',
                    function: 'getUserProfile',
                    script: '/settings/settings',
                    data: this.env.uid,
                    token: this.env.user.token
                }
            });
            console.log('$login.ts => user logged in : ' + this.$localStorage.bpuser.name);
            for (var k in this.env.user) {
                if (this.env.user.hasOwnProperty(k)) {
                }
            }
            if (cd) {
                cd();
            }
        }
        else {
            console.log('$login => no cookie found...anywhere... revoking');
            this.env.revokeUser();
        }
    };
    LoginService.prototype.getCookie = function (name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    };
    LoginService.$inject = [
        '$localStorage', 'env', 'jwtHelper', 'DTS', 'socket'
    ];
    return LoginService;
}());
angular
    .module('application')
    .service('$login', LoginService);

//# sourceMappingURL=login.js.map
